import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import JoditEditor from "jodit-react";
import useApi from "../../core/customhook/useApi";

const TimeSheet = () => {
  const [modalTags, setModalTags] = useState<string[]>([]);
  const [modalMembers, setModalMembers] = useState<string[]>([]);
  const routes = all_routes;
  const [projectData, setProjectData] = useState<any>([]);
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [projectName, setProjectName] = useState("");
  const [taskName, setTaskName] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [taskshowSuggestions, setTaskshowSuggestions] = useState(false);
  const [task, setTask] = useState([]);
  const [count, setCount] = useState(1);
  const navigate = useNavigate();

  const {
    data: taskData,
    loading: taskLoading,
    error: taskError,
  } = useApi("/api/get-all-project-task-emplyee", {
    method: "GET",
    autoCall: true,
    dependencies: [count],
  });
  useEffect(() => {
    if (taskData?.success) {
      setTask(taskData?.data);
    }
  }, [taskData]);

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
    }),
    [],
  );
  const statusChoose = [
    { value: "None", label: "None" },
    { value: "Billable", label: "Billable" },
    { value: "Non Billable", label: "Non Billable" },
  ];
  const columns = [
    {
      title: "Task",
      dataIndex: "task_name",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">{record.task_name}</h6>
      ),
      sorter: (a: any, b: any) => a.task_name.localeCompare(b.task_name),
    },
    {
      title: "Project Name",
      dataIndex: "ProjectName",
      render: (text: string, record: any) => (
        <h6 className="fw-medium">{record.project_name}</h6>
      ),
      sorter: (a: any, b: any) => a.project_name.localeCompare(b.project_name),
    },
    {
      title: "Owner",
      dataIndex: "owner_name",
      sorter: (a: any, b: any) => a.owner_name.localeCompare(b.owner_name),
    },
    {
      title: "StartDate",
      dataIndex: "start_date",
      sorter: (a: any, b: any) => a.start_date.localeCompare(b.start_date),
      render: (value: string) =>
        value ? dayjs(value).format("D MMMM YYYY") : "-",
    },
    {
      title: "EndDate",
      dataIndex: "end_date",
      sorter: (a: any, b: any) => a.end_date.localeCompare(b.end_date),
      render: (value: string) =>
        value ? dayjs(value).format("D MMMM YYYY") : "-",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      render: (text: string) => (
        <div className="d-flex align-items-center">
          <span
            className={`rounded-circle d-flex justify-content-center align-items-center me-2 ${
              text === "High"
                ? "bg-transparent-danger"
                : text === "Low"
                  ? "bg-transparent-success"
                  : "bg-transparent-warning"
            }`}
            style={{ width: 10, height: 10 }}
          >
            <i
              className={`ti ti-point-filled ${
                text === "High"
                  ? "text-danger"
                  : text === "Low"
                    ? "text-success"
                    : "text-warning"
              }`}
            />
          </span>
          <span>{text}</span>
        </div>
      ),
      sorter: (a: any, b: any) => a.priority.localeCompare(b.priority),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => {
        const statusColorMap: Record<string, { bg: string; text: string }> = {
          Pending: { bg: "bg-transparent-warning", text: "text-warning" },
          Ongoing: { bg: "bg-transparent-primary", text: "text-primary" },
          Complete: { bg: "bg-transparent-success", text: "text-success" },
        };

        const { bg, text: textColor } = statusColorMap[text] || {
          bg: "bg-transparent-secondary",
          text: "text-secondary",
        };

        return (
          <div className="d-flex align-items-center">
            <span
              className={`rounded-circle d-flex justify-content-center align-items-center me-2 ${bg}`}
              style={{ width: 10, height: 10 }}
            >
              <i className={`ti ti-point-filled ${textColor}`} />
            </span>
            <span>{text}</span>
          </div>
        );
      },
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    // {
    //   title: "Complete",
    //   dataIndex: "complete", // must match the backend response key
    //   render: (value: number, record: any) => (
    //     <div className="dropdown">
    //       <Link
    //         to="#"
    //         className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
    //         data-bs-toggle="dropdown"
    //       >
    //         <span className="me-2">{value}%</span>
    //       </Link>
    //       <ul
    //         className="dropdown-menu dropdown-menu-end p-2"
    //         style={{
    //           maxHeight: "200px",
    //           overflowY: "auto",
    //           scrollbarWidth: "none",
    //           msOverflowStyle: "none",
    //         }}
    //       >
    //         {[...Array(11)].map((_, i) => {
    //           const percent = i * 10;
    //           return (
    //             <li key={percent}>
    //               <Link
    //                 to="#"
    //                 className={`dropdown-item ${percent === value ? "active" : ""}`}
    //                 onClick={() => {
    //                   console.log("Selected Completion %:", percent);
    //                   console.log("Record:", record);

    //                   // TODO: Replace with API call to update the `complete` value
    //                   // e.g., updateComplete(record.task_id, percent)
    //                 }}
    //               >
    //                 {percent}%
    //               </Link>
    //             </li>
    //           );
    //         })}
    //       </ul>
    //     </div>
    //   ),
    //   sorter: (a: any, b: any) => a.complete - b.complete,
    // },
    {
      title: "Complete",
      dataIndex: "complete",
      render: (value: number) => <span>{value}%</span>,
      sorter: (a: any, b: any) => a.complete - b.complete,
    },
    {
      title: "Tags",
      dataIndex: "tags",
      render: (_: any, record: any) => (
        <button
          className="btn btn-sm btn-outline-secondary"
          data-bs-toggle="modal"
          data-bs-target="#tagsModal"
          onClick={() => setModalTags(record.tags)}
        >
          View
        </button>
      ),
    },
    {
      title: "Team",
      dataIndex: "team_members",
      render: (_: any, record: any) => (
        <button
          className="btn btn-sm btn-outline-primary"
          data-bs-toggle="modal"
          data-bs-target="#membersModal"
          onClick={() => setModalMembers(record.team_members)}
        >
          View
        </button>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_: any, record: any) => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => {
            navigate("/timesheet-logs/" + record.task_id);
          }}
        >
          <i className="ti ti-eye me-1" />
          View
        </button>
      ),
    },
  ];

  const postData = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("My content ", content);
  };

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Tasks</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Employee</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Task
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            {/* Project list */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Task List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  {/* <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Select Status
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Active
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Inactive
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Sort By : Last 7 Days
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Desending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
              <div className="card-body p-0">
                <Table dataSource={task} columns={columns} Selection={false} />
              </div>
            </div>
            {/* / Project list  */}
          </div>
          <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
            <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

      {/* Add Project */}
      <div className="modal fade" id="add_project" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="modal-title me-2">Add Time Log </h5>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="add-info-fieldset ">
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="basic-tab"
                  tabIndex={0}
                >
                  <form onSubmit={postData}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Project Name<sup className="text-danger">*</sup>
                            </label>
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type="text"
                                name="projectName"
                                className="form-control me-2"
                                placeholder="Project Name"
                                style={{ width: "100%" }}
                                value={projectName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  const value = e.target.value;
                                  setProjectName(value);
                                  if (value.trim()) {
                                    const matches = projectData.filter(
                                      (item: any) =>
                                        item.ProjectName.toLowerCase().includes(
                                          value.toLowerCase(),
                                        ),
                                    );
                                    setFilteredSuggestions(matches);
                                    setShowSuggestions(true);
                                  } else {
                                    setFilteredSuggestions([]);
                                    setShowSuggestions(false);
                                  }
                                }}
                              />
                              {showSuggestions &&
                                filteredSuggestions.length > 0 && (
                                  <div
                                    className="dropdown-menu show"
                                    style={{
                                      width: "100%",
                                      maxHeight: "350px",
                                      overflowY: "auto",
                                      position: "absolute",
                                      zIndex: 1000,
                                    }}
                                  >
                                    <table className="table table-bordered table-hover mb-0">
                                      <thead className="table-light sticky-top">
                                        <tr>
                                          <th>Project Name</th>
                                          <th>Cost Center Code</th>
                                          <th>Department</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {filteredSuggestions.map(
                                          (item, index) => (
                                            <tr
                                              key={index}
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                setProjectName(
                                                  item.ProjectName,
                                                );
                                                setShowSuggestions(false);
                                              }}
                                            >
                                              <td>{item.ProjectName}</td>
                                              <td>{item.CostCenterCode}</td>
                                              <td>{item.Department}</td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Tasks<sup className="text-danger">*</sup>
                            </label>
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type="text"
                                name="taskName"
                                className="form-control me-2"
                                placeholder="Task Name"
                                style={{ width: "100%" }}
                                value={taskName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  const value = e.target.value;
                                  setTaskName(value);
                                  if (value.trim()) {
                                    const matches = taskData.filter(
                                      (item: any) =>
                                        item.TaskName.toLowerCase().includes(
                                          value.toLowerCase(),
                                        ),
                                    );
                                    setFilteredSuggestions(matches);
                                    setTaskshowSuggestions(true);
                                  } else {
                                    setFilteredSuggestions([]);
                                    setTaskshowSuggestions(false);
                                  }
                                }}
                              />
                              {taskshowSuggestions &&
                                filteredSuggestions.length > 0 && (
                                  <div
                                    className="dropdown-menu show"
                                    style={{
                                      width: "100%",
                                      maxHeight: "350px",
                                      overflowY: "auto",
                                      position: "absolute",
                                      zIndex: 1000,
                                    }}
                                  >
                                    <table className="table table-bordered table-hover mb-0">
                                      <thead className="table-light sticky-top">
                                        <tr>
                                          <th>Task Id</th>
                                          <th>Task Name</th>
                                          <th>Start Date</th>
                                          <th>Work Hours</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {filteredSuggestions.map(
                                          (item, index) => (
                                            <tr
                                              key={index}
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                setTaskName(item.TaskName);
                                                setTaskshowSuggestions(false);
                                              }}
                                            >
                                              <td>{item.TaskId}</td>
                                              <td>{item.TaskName}</td>
                                              <td>{item.StartDate}</td>
                                              <td>{item.WorkHours}</td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Other Log Entries
                              <sup className="text-danger">*</sup>
                            </label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder=" Other Log Entries"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Date<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    format={{
                                      format: "DD-MM-YYYY",
                                      type: "mask",
                                    }}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    disabledDate={(current) =>
                                      current &&
                                      current.isBefore(dayjs().startOf("day"))
                                    }
                                  />
                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  User<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Template Name"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Daily Log(Hours)
                                  <sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <input
                                    type="text"
                                    className="form-control datetimepicker"
                                    placeholder="00:00"
                                    defaultValue="12:20"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Billing Type
                                </label>
                                <select
                                  className="form-control"
                                  name="billing_type"
                                >
                                  {statusChoose.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Notes</label>
                            <JoditEditor
                              ref={editor}
                              value={content}
                              config={config}
                              tabIndex={1} // tabIndex of textarea
                              onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                              onChange={(newContent) => {}}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-0">
                            <label className="form-label">Upload Files</label>
                            <input className="form-control" type="file" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button className="btn btn-primary" type="submit">
                          Add Time Log
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Project */}
      {/* Edit Project */}
      <div className="modal fade" id="edit_project" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="modal-title me-2">Edit Time Log </h5>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="add-info-fieldset ">
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="basic-tab"
                  tabIndex={0}
                >
                  <form onSubmit={postData}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Project Name<sup className="text-danger">*</sup>
                            </label>
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type="text"
                                name="projectName"
                                className="form-control me-2"
                                placeholder="Project Name"
                                style={{ width: "100%" }}
                                value={projectName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  const value = e.target.value;
                                  setProjectName(value);
                                  if (value.trim()) {
                                    const matches = projectData.filter(
                                      (item: any) =>
                                        item.ProjectName.toLowerCase().includes(
                                          value.toLowerCase(),
                                        ),
                                    );
                                    setFilteredSuggestions(matches);
                                    setShowSuggestions(true);
                                  } else {
                                    setFilteredSuggestions([]);
                                    setShowSuggestions(false);
                                  }
                                }}
                              />
                              {showSuggestions &&
                                filteredSuggestions.length > 0 && (
                                  <div
                                    className="dropdown-menu show"
                                    style={{
                                      width: "100%",
                                      maxHeight: "350px",
                                      overflowY: "auto",
                                      position: "absolute",
                                      zIndex: 1000,
                                    }}
                                  >
                                    <table className="table table-bordered table-hover mb-0">
                                      <thead className="table-light sticky-top">
                                        <tr>
                                          <th>Project Name</th>
                                          <th>Cost Center Code</th>
                                          <th>Department</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {filteredSuggestions.map(
                                          (item, index) => (
                                            <tr
                                              key={index}
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                setProjectName(
                                                  item.ProjectName,
                                                );
                                                setShowSuggestions(false);
                                              }}
                                            >
                                              <td>{item.ProjectName}</td>
                                              <td>{item.CostCenterCode}</td>
                                              <td>{item.Department}</td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Tasks<sup className="text-danger">*</sup>
                            </label>
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type="text"
                                name="taskName"
                                className="form-control me-2"
                                placeholder="Task Name"
                                style={{ width: "100%" }}
                                value={taskName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  const value = e.target.value;
                                  setTaskName(value);
                                  if (value.trim()) {
                                    const matches = taskData.filter(
                                      (item: any) =>
                                        item.TaskName.toLowerCase().includes(
                                          value.toLowerCase(),
                                        ),
                                    );
                                    setFilteredSuggestions(matches);
                                    setTaskshowSuggestions(true);
                                  } else {
                                    setFilteredSuggestions([]);
                                    setTaskshowSuggestions(false);
                                  }
                                }}
                              />
                              {taskshowSuggestions &&
                                filteredSuggestions.length > 0 && (
                                  <div
                                    className="dropdown-menu show"
                                    style={{
                                      width: "100%",
                                      maxHeight: "350px",
                                      overflowY: "auto",
                                      position: "absolute",
                                      zIndex: 1000,
                                    }}
                                  >
                                    <table className="table table-bordered table-hover mb-0">
                                      <thead className="table-light sticky-top">
                                        <tr>
                                          <th>Task Id</th>
                                          <th>Task Name</th>
                                          <th>Start Date</th>
                                          <th>Work Hours</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {filteredSuggestions.map(
                                          (item, index) => (
                                            <tr
                                              key={index}
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                setTaskName(item.TaskName);
                                                setTaskshowSuggestions(false);
                                              }}
                                            >
                                              <td>{item.TaskId}</td>
                                              <td>{item.TaskName}</td>
                                              <td>{item.StartDate}</td>
                                              <td>{item.WorkHours}</td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Other Log Entries
                              <sup className="text-danger">*</sup>
                            </label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder=" Other Log Entries"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Date<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    format={{
                                      format: "DD-MM-YYYY",
                                      type: "mask",
                                    }}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    disabledDate={(current) =>
                                      current &&
                                      current.isBefore(dayjs().startOf("day"))
                                    }
                                  />
                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  User<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Template Name"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Daily Log(Hours)
                                  <sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <input
                                    type="text"
                                    className="form-control datetimepicker"
                                    placeholder="00:00"
                                    defaultValue="12:20"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Billing Type
                                </label>
                                <select
                                  className="form-control"
                                  name="billing_type"
                                >
                                  {statusChoose.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Notes</label>
                            <JoditEditor
                              ref={editor}
                              value={content}
                              config={config}
                              tabIndex={1} // tabIndex of textarea
                              onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                              onChange={(newContent) => {}}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-0">
                            <label className="form-label">Upload Files</label>
                            <input className="form-control" type="file" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button className="btn btn-primary" type="submit">
                          Edit Time Log
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Project */}
      {/* Add Project Success */}
      <div className="modal fade" id="success_modal" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center p-3">
                <span className="avatar avatar-lg avatar-rounded bg-success mb-3">
                  <i className="ti ti-check fs-24" />
                </span>
                <h5 className="mb-2">Project Added Successfully</h5>
                <p className="mb-3">
                  Stephan Peralt has been added with Client ID :{" "}
                  <span className="text-primary">#pro - 0004</span>
                </p>
                <div>
                  <div className="row g-2">
                    <div className="col-6">
                      <Link
                        to={all_routes.project}
                        className="btn btn-dark w-100"
                      >
                        Back to List
                      </Link>
                    </div>
                    <div className="col-6">
                      <Link
                        to={all_routes.projectdetails}
                        className="btn btn-primary w-100"
                      >
                        Detail Page
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Project Success */}

      {/* Tags Modal */}
      <div className="modal fade" id="tagsModal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Task Tags</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {modalTags.length > 0 ? (
                modalTags.map((tag, index) => (
                  <span key={index} className="badge bg-info me-1">
                    {tag}
                  </span>
                ))
              ) : (
                <p>No tags available</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Team Members Modal */}
      <div className="modal fade" id="membersModal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Team Members</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {modalMembers.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Employee ID</th>
                        <th scope="col">Employee Name</th>
                        <th scope="col">Designation</th>
                        <th scope="col">Department</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modalMembers.map((item: any, index: number) => (
                        <tr key={item.employee_id}>
                          <td>{index + 1}</td>
                          <td>{item.employee_id}</td>
                          <td>{item.employee_name}</td>
                          <td>{item.designation}</td>
                          <td>{item.department}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>No team members assigned.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TimeSheet;
